
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { addDriver } from '../../Services/Operations/ProductAPI';

const AddDriverModal = ({ busOwnerId, token, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    mobileNumber: '',
    licenseNumber: '',
    experience: '',
    assignedBus: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!formData.name.trim()) {
        toast.error('Driver name is required');
        setLoading(false);
        return;
      }

      if (!formData.mobileNumber.trim()) {
        toast.error('Mobile number is required');
        setLoading(false);
        return;
      }

      const driverData = {
        name: formData.name.trim(),
        mobileNumber: formData.mobileNumber.trim(),
        busOwner: busOwnerId,
        licenseNumber: formData.licenseNumber.trim() || null,
        experience: parseInt(formData.experience) || 0,
        assignedBus: formData.assignedBus || null
      };

      const response = await addDriver(driverData, token);

      if (response.success) {
        toast.success('Driver added successfully');
        if (onSuccess) onSuccess(response.data);
        onClose();
      } else {
        toast.error(response.message || 'Failed to add driver');
      }
    } catch (error) {
      console.error('Error adding driver:', error);
      toast.error(error.response?.data?.message || 'Failed to add driver');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fm-modal-overlay" onClick={onClose}>
      <div className="fm-modal-content fm-glass-effect add-staff-modal" onClick={(e) => e.stopPropagation()}>
        <div className="fm-modern-header">
          <div className="fm-header-content">
            <div className="fm-header-title">
              <div className="fm-header-icon-wrapper">
                <span>👤</span>
              </div>
              <div className="fm-header-text">
                <h1>Add New Driver</h1>
                <p>Enter driver details to register</p>
              </div>
            </div>
            <button className="fm-close-button" onClick={onClose}>×</button>
          </div>
        </div>

        <div className="fm-modal-body add-staff-body">
          <form onSubmit={handleSubmit} className="fm-add-staff-form">
            <div className="fm-form-grid">

              <div className="fm-form-group full-width">
                <label className="fm-form-label">
                  Full Name <span className="fm-required">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter driver's full name"
                  className="fm-form-input"
                  required
                />
              </div>


              <div className="fm-form-group">
                <label className="fm-form-label">
                  Mobile Number <span className="fm-required">*</span>
                </label>
                <input
                  type="tel"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  placeholder="10-digit mobile number"
                  className="fm-form-input"
                  maxLength="10"
                  required
                />
              </div>


              <div className="fm-form-group">
                <label className="fm-form-label">License Number</label>
                <input
                  type="text"
                  name="licenseNumber"
                  value={formData.licenseNumber}
                  onChange={handleChange}
                  placeholder="e.g., WB1234567890123"
                  className="fm-form-input"
                />
              </div>


              <div className="fm-form-group">
                <label className="fm-form-label">Experience (Years)</label>
                <input
                  type="number"
                  name="experience"
                  value={formData.experience}
                  onChange={handleChange}
                  placeholder="0"
                  className="fm-form-input"
                  min="0"
                />
              </div>
            </div>

            <div className="fm-form-actions">
              <button type="button" className="fm-cancel-btn" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="fm-submit-btn" disabled={loading}>
                {loading ? (
                  <>
                    <span className="fm-spinner-small"></span>
                    Adding...
                  </>
                ) : (
                  '👤 Add Driver'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddDriverModal;